// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".twYoukZYn0Ea5pKSW3AWWA\\=\\= .error-message{background:var(--gray40);border-left:5px solid var(--red);color:var(--gray100);padding:20px}", "",{"version":3,"sources":["/app/client_react/src/components/CancelCardModal/CancelCardModal.styl"],"names":[],"mappings":"AAGE,2CACE,wBAAY,CACZ,gCAAa,CACb,oBAAO,CACP,YAAS","file":"CancelCardModal.styl","sourcesContent":["@import '../../../../client/styles/vars';\n\n:local(.global) {\n  .error-message {\n    background: var(--gray40);\n    border-left: 5px solid var(--red);\n    color: var(--gray100);\n    padding: 20px;\n  }\n}\n"]}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"global": "twYoukZYn0Ea5pKSW3AWWA=="
};
module.exports = ___CSS_LOADER_EXPORT___;
